"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var _tokens = _interopRequireDefault(require("./tokens"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var theme = (0, _styles.createMuiTheme)();
theme.shadows[1] = _tokens["default"].shadow.dp1;
theme.shadows[2] = _tokens["default"].shadow.dp2;
theme.shape.borderRadius = _tokens["default"].radii.semiRounded;
theme.palette.divider = _tokens["default"].colors.neutral.c300;
theme.palette.common = {
  black: _tokens["default"].colors.black,
  white: _tokens["default"].colors.white
};
theme.palette.text = _objectSpread(_objectSpread({}, theme.palette.text), {}, {
  primary: _tokens["default"].colors.neutral.c700,
  secondary: _tokens["default"].colors.neutral.c500,
  disabled: _tokens["default"].colors.neutral.c400,
  hint: _tokens["default"].colors.neutral.c400
});
theme.palette.background = {
  "default": _tokens["default"].colors.neutral.c50,
  paper: _tokens["default"].colors.neutral.c100
};
theme.palette.primary = {
  light: _tokens["default"].colors.blue.c90,
  main: _tokens["default"].colors.blue.c100,
  dark: _tokens["default"].colors.blue.c110,
  contrastText: _tokens["default"].colors.neutral.c100
};
theme.palette.secondary = _objectSpread(_objectSpread({}, theme.palette.secondary), {}, {
  light: _tokens["default"].colors.neutral.c500,
  main: _tokens["default"].colors.neutral.c600,
  dark: _tokens["default"].colors.neutral.c700
});
theme.palette.error = {
  light: _tokens["default"].colors.red.c90,
  main: _tokens["default"].colors.red.c100,
  dark: _tokens["default"].colors.red.c110,
  contrastText: _tokens["default"].colors.neutral.c100
};
theme.palette.success = {
  light: _tokens["default"].colors.green.c90,
  main: _tokens["default"].colors.green.c100,
  dark: _tokens["default"].colors.green.c110,
  contrastText: _tokens["default"].colors.neutral.c100
};
theme.palette.info = {
  light: _tokens["default"].colors.blue.c90,
  main: _tokens["default"].colors.blue.c100,
  dark: _tokens["default"].colors.blue.c110,
  contrastText: _tokens["default"].colors.neutral.c100
};
theme.palette.warning = {
  light: _tokens["default"].colors.yellow.c90,
  main: _tokens["default"].colors.yellow.c100,
  dark: _tokens["default"].colors.yellow.c110,
  contrastText: _tokens["default"].colors.neutral.c100
};
theme.palette.grey = _objectSpread(_objectSpread({}, theme.palette.grey), {}, {
  50: _tokens["default"].colors.neutral.c50,
  100: _tokens["default"].colors.neutral.c100,
  200: _tokens["default"].colors.neutral.c200,
  300: _tokens["default"].colors.neutral.c300,
  400: _tokens["default"].colors.neutral.c400,
  500: _tokens["default"].colors.neutral.c500,
  600: _tokens["default"].colors.neutral.c600,
  700: _tokens["default"].colors.neutral.c700,
  800: _tokens["default"].colors.neutral.c800,
  900: _tokens["default"].colors.neutral.c900
});
theme.typography.fontFamily = _tokens["default"].fontFamily.magalu;
theme.typography.fontSize = 14;
theme.typography.fontWeightBold = _tokens["default"].fontWeight.bold;
theme.typography.fontWeightMedium = _tokens["default"].fontWeight.medium;
theme.typography.fontWeightRegular = _tokens["default"].fontWeight.regular;
theme.typography.h1 = {
  fontFamily: _tokens["default"].fontFamily.magalu,
  fontWeight: _tokens["default"].fontWeight.bold,
  fontSize: _tokens["default"].fontSize.xxxlarge,
  lineHeight: _tokens["default"].lineHeight.xxxlarge,
  letterSpacing: 0
};
theme.typography.h2 = {
  fontFamily: _tokens["default"].fontFamily.magalu,
  fontWeight: _tokens["default"].fontWeight.bold,
  fontSize: _tokens["default"].fontSize.xxlarge,
  lineHeight: _tokens["default"].lineHeight.xxlarge,
  letterSpacing: 0
};
theme.typography.h3 = {
  fontFamily: _tokens["default"].fontFamily.magalu,
  fontWeight: _tokens["default"].fontWeight.bold,
  fontSize: _tokens["default"].fontSize.xlarge,
  lineHeight: _tokens["default"].lineHeight.xlarge,
  letterSpacing: 0
};
theme.typography.h4 = {
  fontFamily: _tokens["default"].fontFamily.magalu,
  fontWeight: _tokens["default"].fontWeight.bold,
  fontSize: _tokens["default"].fontSize.large,
  lineHeight: _tokens["default"].lineHeight.large,
  letterSpacing: 0
};
theme.typography.h5 = {
  fontFamily: _tokens["default"].fontFamily.magalu,
  fontWeight: _tokens["default"].fontWeight.bold,
  fontSize: _tokens["default"].fontSize.medium,
  lineHeight: _tokens["default"].lineHeight.medium,
  letterSpacing: 0
};
theme.typography.h6 = {
  fontFamily: _tokens["default"].fontFamily.magalu,
  fontWeight: _tokens["default"].fontWeight.bold,
  fontSize: _tokens["default"].fontSize.small,
  lineHeight: _tokens["default"].lineHeight.small,
  letterSpacing: 0
};
theme.typography.subtitle1 = {
  fontFamily: _tokens["default"].fontFamily.magalu,
  fontWeight: _tokens["default"].fontWeight.medium,
  fontSize: _tokens["default"].fontSize["default"],
  lineHeight: _tokens["default"].lineHeight.medium,
  letterSpacing: 0
};
theme.typography.subtitle2 = {
  fontFamily: _tokens["default"].fontFamily.magalu,
  fontWeight: _tokens["default"].fontWeight.bold,
  fontSize: _tokens["default"].fontSize.small,
  lineHeight: _tokens["default"].lineHeight.small,
  letterSpacing: 0
};
theme.typography.body1 = {
  fontFamily: _tokens["default"].fontFamily.magalu,
  fontWeight: _tokens["default"].fontWeight.regular,
  fontSize: _tokens["default"].fontSize["default"],
  lineHeight: _tokens["default"].lineHeight.small,
  letterSpacing: 0
};
theme.typography.body2 = {
  fontFamily: _tokens["default"].fontFamily.magalu,
  fontWeight: _tokens["default"].fontWeight.regular,
  fontSize: _tokens["default"].fontSize.small,
  lineHeight: _tokens["default"].lineHeight.xsmall,
  letterSpacing: 0
};
theme.typography.button = {
  fontFamily: _tokens["default"].fontFamily.magalu,
  fontWeight: _tokens["default"].fontWeight.medium,
  fontSize: _tokens["default"].fontSize["default"],
  lineHeight: _tokens["default"].lineHeight.small,
  letterSpacing: 0,
  textTransform: 'initial'
};
theme.typography.caption = {
  fontFamily: _tokens["default"].fontFamily.magalu,
  fontWeight: _tokens["default"].fontWeight.medium,
  fontSize: _tokens["default"].fontSize.xsmall,
  lineHeight: _tokens["default"].lineHeight.xsmall,
  letterSpacing: 0
};
theme.typography.overline = {
  fontFamily: _tokens["default"].fontFamily.magalu,
  fontWeight: _tokens["default"].fontWeight.medium,
  fontSize: _tokens["default"].fontSize["default"],
  lineHeight: _tokens["default"].lineHeight.small,
  letterSpacing: 0
};
var _default = theme;
exports["default"] = _default;